// Keyboard router for the camera: tells a USB/Bluetooth barcode scanner
// (fast keystrokes ending in Enter) apart from a human pressing keys.
//   Space / Enter           → single shot
//   B or Shift+Space        → burst
//   ≥3 fast chars + Enter   → scan (sets SKU, then fires)
const SCAN_GAP_MS = 60; // scanners type ~5–30 ms per char
const MIN_SCAN_LEN = 3;

export function createKeyRouter({ onShot, onBurst, onScan }) {
  let buf = "";
  let last = 0;
  let fast = true;
  let settle = null;

  const reset = () => { buf = ""; fast = true; clearTimeout(settle); settle = null; };

  return (e) => {
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target?.tagName || "")) return;
    const now = performance.now();

    if (e.key === "Enter" || e.key === "Tab") {
      if (buf.length >= MIN_SCAN_LEN && fast) {
        e.preventDefault();
        const code = buf;
        reset();
        onScan(code);
        return;
      }
      const wasBuffer = buf.length > 0;
      reset();
      if (e.key === "Enter" && !e.repeat) { e.preventDefault(); if (!wasBuffer) onShot(); }
      return;
    }
    if (e.code === "Space") {
      if (e.repeat) return;
      e.preventDefault();
      reset();
      if (e.shiftKey) onBurst(); else onShot();
      return;
    }
    if (e.key.length !== 1 || e.ctrlKey || e.metaKey || e.altKey) return;

    // Printable char: buffer it; decide once typing settles.
    if (buf && now - last > SCAN_GAP_MS) fast = false;
    buf += e.key;
    last = now;
    clearTimeout(settle);
    settle = setTimeout(() => {
      if (buf === "b" || buf === "B") onBurst();
      reset();
    }, SCAN_GAP_MS * 2);
  };
}
